import { Box, Circle, useColorModeValue, HStack } from '@chakra-ui/react';

const MessageStatus = ({ status, type, showLabel = true }) => {
  const batchStatusConfig = {
    processing: {
      label: 'Processing',
      color: 'warning',
    },
    cancelling: {
      label: 'Cancelling',
      color: 'warning',
    },
    processed: {
      label: 'Processed',
      color: 'warning',
    },
    scheduled: {
      label: 'Scheduled',
      color: 'blue.500',
    },
    completed: {
      label: 'Completed',
      color: 'success',
    },
    successful: {
      label: 'Successful',
      color: 'success',
    },
    failed: {
      label: 'Failed',
      color: 'error',
    },
    partially_cancelled: {
      label: 'Partially Cancelled',
      color: 'error',
    },
    cancelled: {
      label: 'Cancelled',
      color: 'error',
    },
    cancellation_failed: {
      label: 'Cancellation Failed',
      color: 'error',
    },
    validating: {
      label: 'Validating',
      color: 'warning',
    },
    sending: {
      label: 'Sending',
      color: 'warning',
    },
    completedWithErrors: {
      label: 'Completed with Errors',
      color: 'error',
    },
  };

  const logStatusConfig = {
    pending: {
      label: 'Pending',
      color: 'gray',
    },
    scheduled: {
      label: 'Scheduled',
      color: 'blue.500',
    },
    queued: {
      label: 'Queued',
      color: 'orange',
    },
    sent: {
      label: 'Sent',
      color: 'green',
    },
    failed: {
      label: 'Failed',
      color: 'error',
    },
    delivered: {
      label: 'Delivered',
      color: 'green',
    },
    undelivered: {
      label: 'Undelivered',
      color: 'error',
    },
    accepted: {
      label: 'Accepted',
      color: 'blue',
    },
    cancelled: {
      label: 'Cancelled',
      color: 'error',
    },
    cancellation_failed: {
      label: 'Cancellation Failed',
      color: 'error',
    },
  };

  const passCreationBatch = {
    processing: {
      label: 'Processing',
      color: 'warning',
    },
    successful: {
      label: 'Successful',
      color: 'success',
    },
    failed: {
      label: 'Failed',
      color: 'error',
    },
  };

  const readerSetup = {
    completed: {
      label: 'Completed',
      color: 'success',
    },
    in_progress: {
      label: 'In progress',
      color: 'warning',
    },
    not_required: {
      label: 'Manual setup selected',
      color: 'gray',
    },
    failed: {
      label: 'Failed',
      color: 'error',
    },
  };

  const statusConfig =
    type === 'log'
      ? logStatusConfig
      : type === 'pass'
        ? passCreationBatch
        : type === 'reader_setup'
          ? readerSetup
          : batchStatusConfig;

  const currentStatus = statusConfig[String(status)] || {
    label: 'Unknown',
    color: 'gray',
  };

  return (
    <HStack
      pr={showLabel ? '12px' : '0px'}
      pl={showLabel ? '12px' : '0px'}
      py={showLabel ? '7px' : '0px'}
      bg={showLabel ? '#ddd' : 'transparent'}
      borderRadius="20px"
      justifyContent="center"
      alignItems="center"
      width="fit-content"
    >
      <Circle bg={currentStatus.color} size="12px" role="status-circle" />
      {showLabel && (
        <Box
          fontSize="12px"
          top="1px"
          pos="relative"
          pb="1px"
          color="secondaryDark"
          whiteSpace="nowrap"
        >
          {currentStatus.label}
        </Box>
      )}
    </HStack>
  );
};

export default MessageStatus;
